<template>
	<ul class="sort-search">
		<li class="sort-list-head">
			<div>
				<span>SORT BY</span><span class="font-weight-bold pl-1">{{ sortText }}</span>
			</div>
			<span class="icon-sort"></span>
		</li>
		<li>
			<ul class="sort-search-sublist">
				<li :class="{ selected: selectedMode === 5 }">
					<a :href="hottest">Poplular</a>
				</li>
				<li :class="{ selected: selectedMode === 1 }">
					<a :href="newtoold">New</a>
				</li>
				<li :class="{ selected: selectedMode === 4 }">
					<a :href="lowtohigh">Price(Low-High)</a>
				</li>
				<li :class="{ selected: selectedMode === 3 }">
					<a :href="hightolow">Price(High-Low)</a>
				</li>
			</ul>
		</li>
	</ul>
</template>

<script>
export default {
	name: "filterTmpl",
	data: function () {
		return {
			searchLocation: window.location.search,
			keyStr: "OM=",
			selectedMode: null,
		};
	},
	created: function () {
		this.selectedMode = this.getOrderMode();
	},
	computed: {
		lowtohigh: function () {
			return this.locationSearchFilter(4);
		},
		hightolow: function () {
			return this.locationSearchFilter(3);
		},
		newtoold: function () {
			return this.locationSearchFilter(1);
		},
		hottest: function () {
			return this.locationSearchFilter(5);
		},
		sortText() {
			switch (this.selectedMode) {
				case 1:
					return "New";
				case 3:
					return "Price(High-Low)";
				case 4:
					return "Price(Low-High)";
				case 5:
					return "Poplular";
				default:
					break;
			}
		},
	},
	methods: {
		getOrderMode: function () {
			var args = this.searchLocation.split("&");

			var ModeStr = "";

			for (let i = 0; i < args.length; i++) {
				if (args[i].indexOf("OM") !== -1) {
					ModeStr = args[i];
				}
			}

			if (window.location.pathname === "/recent" && ModeStr.length === 0) {
				return 1;
			} else if (window.location.pathname === "/hot" && ModeStr.length === 0) {
				return 5;
			} else if (window.location.pathname === "/favorite" && ModeStr.length === 0) {
				return null;
			} else if (ModeStr.length === 0) {
				return 1;
			} else {
				return parseInt(ModeStr.charAt(ModeStr.length - 1));
			}
		},
		locationSearchFilter: function (orderNum) {
			var argsString = "";
			if (window.location.toString().indexOf("?") !== -1) {
				var args = window.location.toString().split("?")[1].split("&");

				let i = 0;
				while (i < args.length) {
					if (args[i].indexOf("OM") !== -1) {
						args.splice(i, 1);
					} else if (args[i].indexOf("P=") !== -1) {
						args.splice(i, 1);
					} else {
						i++;
					}
				}

				if (args.length !== 0) {
					// 存在其他條件參數
					argsString = `${args.join("&")}&`;
				} else {
					argsString = `${args.join("&")}`;
				}
			}

			return "?" + argsString + this.keyStr + orderNum;
		},
	},
};
</script>
